<template>
  <div>
    <transition name="slide">
      <div
        id="sidebar-wrapper"
        class="collapse font-weight-bold show"
        v-show="showing"
        v-click-outside="hide"
      >
        <ul class="sidebar-nav">
          <li class="sidebar-brand">
            <div class="row h-100 align-items-center text-center">
              <div class="col p-0 m-0 mt-2">
                <a class="navbar-brand p-0" :href="logoLinkUrl">
                  <img id="homeNavLogo" class="img-fluid" :src="uniTruthsLogoUrl" alt="Uni-Truths" />
                </a>
              </div>
            </div>
          </li>

          <slot></slot>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import SidebarElement from "./SidebarElement";
export default {
  name: "Sidebar",
  components: { SidebarElement },
  props: {
    title: {
      required: false,
      default: "Developer Sidebar",
      type: String
    },
    uniTruthsLogoUrl: {
      required: false,
      type: String
    },
    logoLinkUrl: {
      required: false,
      type: String
    }
  },

  data() {
    return {
      showing: false,
      shown: false
    };
  },

  computed: {},

  mounted() {
    var self = this;
    SidebarEventBus.$on("show", function() {
      self.show();
    });
    SidebarEventBus.$on("hide", function() {
      self.hide();
    });
  },

  methods: {
    show() {
      this.showing = true;
      setTimeout(() => {
        this.shown = true;
      }, 50); //(don't open and immediatly close it...)
    },
    hide() {
      if (this.shown) {
        this.showing = false;
        this.shown = false;
      }
    }
  }
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
}

.sidebar-panel {
  overflow-y: auto;
  background-color: #130f40;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 999;
  padding: 3rem 20px 2rem 20px;
  width: 300px;
}
</style>